<template>
  <div>
    <gj-table
        ref="gjTable"
        name="saleReturnRank"
        :index="false"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="534"
        row-id="id"
        :tree-config="{transform: false, lazy: true, hasChild: 'hasChild',loadMethod: loadChildrenMethod}"
    >

      <template v-slot:header:asin>
        <span v-if="type === 'asin'">ASIN</span>
        <span v-if="type === 'variationAsin'">父ASIN/子ASIN</span>
        <span v-if="type === 'msku'">MSKU</span>
      </template>

      <template v-slot:index="{row,index}">
        {{rank(row,index)}}
      </template>

<!--      <template v-slot:header:product>-->
<!--        <app-dashboard-rank-product-header :type="type"></app-dashboard-rank-product-header>-->
<!--      </template>-->
<!--      -->
<!--      <template v-slot:product="{ row }">-->
<!--        <app-dashboard-rank-product-column-->
<!--            :type="type"-->
<!--            :row="row">-->
<!--        </app-dashboard-rank-product-column>-->
<!--      </template>-->

      <template v-slot:picture="{row}">
        <app-dashboard-rank-picture-column
            :row="row"
            :groupType="type"
        ></app-dashboard-rank-picture-column>
      </template>

      <template v-slot:asin="{row}">
        <template v-if="type !== 'msku'">
          <gj-link v-if="row.hasChild" :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <span v-else>{{row.msku | defaultShow}}</span>
      </template>

      <template v-slot:refundQuantity="{row}">
        <span class="colorGreen">{{row.refundQuantity | defaultShow}}</span>
      </template>

      <template #empty v-if="!showStoreMask">
        <div></div>
      </template>

    </gj-table>
  </div>
</template>

<script>
  import {queryMixin} from "../../../../../../minxins";
  import {getContributionRank, getSaleReturnRank} from "../../../../../../api/dashboard";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {countryMarketParams} from "../../../../../../utils/common";
  import AppDashboardRankProductHeader from "./components/dashboard-rank-product-header";
  import AppDashboardRankProductColumn from "./components/dashboard-rank-product-column";
  import AppDashboardRankPictureColumn from "./components/dashboard-rank-picture-column";
  import {rankMixin} from "./mixin";

  export default {
    name: "app-dashboard-return-rank",
    components: {AppDashboardRankPictureColumn, AppDashboardRankProductColumn, AppDashboardRankProductHeader},
    mixins: [queryMixin, rankMixin],
    data() {
      return {
        rankName: 'return',
        tableData: [],
        columns: [
          {id: 'index', header: '排名', field: 'slot:index', width: '60px'},
          {id: 'picture', header: '图片', field: 'slot:picture', width: '50px'},
          {id: 'listingTitle', header: '商品标题', field: 'listingTitle', minWidth: '300px', overflowLine: 2},
          {id: 'asin', header: 'slot:asin', field: 'slot:asin', width: '140px'},
          // {id: 'product', header: 'slot:product', field: 'slot:product', minWidth: '300px'},
          {id: 'return', header: '退款量', field: 'slot:refundQuantity', align: 'right', width: '80px', sortable: false},
          {id: 'sale', header: '销量', field: 'saleQuantity', width: '80px', align: 'right', sortable: false},
          {id: 'sales', header: '退款率', field: 'refundRate', align: 'right', suffix: '%', width: '80px', sortable: false},
          {id: 'returns', header: '退款金额', field: 'refundSales', prefix: 'currencySymbol', align: 'right', width: '110px', sortable: false},
        ],
      }
    },
    methods: {
      //异步获取父asin展开数据
      loadChildrenMethod ({ row }) {
        return getSaleReturnRank({
          currency: this.dashboardCurrency,
          groupType: 'asin',
          month:this.month,
          variationAsin: row.variationAsin,
          marketIds: row.marketId
        })
      },
      $gjQuery() {
        if(!this.showStoreMask){
          return
        }
        // 查询
        this.loading = true;
        getSaleReturnRank({
          currency: this.dashboardCurrency,
          groupType: this.type,
          month:this.month,
          countrys: this.countryMarket.countryIds.join(','),// 国家
          marketIds: this.countryMarket.marketIds.join(','),// 店铺
        })
          .then((data) => {
            this.tableData = data || [];
            if(this.type === 'variationAsin'){
              this.tableData.forEach((r,index)=>{
                r.hasChild = true;
              })
            }
          })
          .complete(() => this.loading = false);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
</style>



